import { Box, Typography, useTheme } from '@mui/material'
import { getPlatform } from '../../../utilities/orientationAndPlatform'

export function RevertAllChangesButton({...params}){

    let theme = useTheme()
    let revertButtonFontColor = theme.palette.ChannelPage.subheader.fontfilled

    let handleRevertAllChangesClick = params.handleRevertAllChangesClick
    let updatedFieldsCountState = params.updatedFieldsCountState

    let revertButtonState = params.revertButtonState
    let setRevertButtonState = params.setRevertButtonState

    let buttonText = ''
    let buttonWidth = ''
    let platform = getPlatform()
    if (platform === 'mobile') {
        buttonText = 'Revert All'
        buttonWidth = '100px'
    }
    else if (platform === 'desktop') {
        buttonText = 'Revert All Changes'
        buttonWidth = '176px'
    }

    const handleButtonHover = (event) => {
        event.preventDefault()
        setRevertButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setRevertButtonState('default')
    }

    let buttonColor = ''
    let buttonOpacity = ''
    if (revertButtonState === 'hover' && updatedFieldsCountState > 0) {
        buttonColor = '#108DF9'
        buttonOpacity = '100%'
    } else if (revertButtonState === 'default' && updatedFieldsCountState > 0) {
        buttonColor = '#04569D'
        buttonOpacity = '100%'
    } 
    else if (updatedFieldsCountState === 0) {
        buttonColor = '#06569D'
        buttonOpacity = '50%'
    }

    return (
        <Box alignSelf={'center'} height={'35px'} width={buttonWidth} padding={'5px 10px'} sx={{backgroundColor: buttonColor, opacity: buttonOpacity}} 
            onClick={handleRevertAllChangesClick}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
        >
            <Typography align={'center'} color={revertButtonFontColor} fontSize={'18px'} fontWeight={400}>{buttonText}</Typography>
        </Box>
    )
}
